import { Duration } from 'luxon';

export const getVideoDuration = (iso: string): string => {
  return Duration.fromISO(iso).toHuman({
    unitDisplay: 'short',
    compactDisplay: 'short',
    notation: 'compact'
  });
};
